import ServiceBase from "@app/shared/serviceBase";
import { ComplianceConnectCountySpecialties, ComplianceConnectFilterOptions, ComplianceConnectNetworkFilterParams, ExceptionReviewStatus, GetRegulatorNetworksQuery, GetRegulatorNetworksResult, IsolatedGapInstances, IssuerComplianceComparison, OpenGaps, UniqueGapFills } from "@app/compliance-connect/regulator/complianceConnectTypes";


/** handles communication across the wire when interacting with the compliance connect dashboard */
export default class ComplianceConnectService extends ServiceBase {
    private complianceConnectEndpoint = `${this.apiEndpoint}/complianceconnect`;

    public async getFilterOptions(signal?: AbortSignal): Promise<ComplianceConnectFilterOptions> {
        return await this.makeGet<ComplianceConnectFilterOptions>(`filter-options`, null, this.complianceConnectEndpoint, false, undefined, signal);
    }

    public async getNetworkCount(filters?: ComplianceConnectNetworkFilterParams, signal?: AbortSignal): Promise<number> {
        return await this.makeGet<number>(`network-count`, filters, this.complianceConnectEndpoint, false, undefined, signal);
    }

    public async getTopFiveCountySpecialties(filters?: ComplianceConnectNetworkFilterParams, signal?: AbortSignal): Promise<ComplianceConnectCountySpecialties[]> {
      return await this.makeGet<ComplianceConnectCountySpecialties[]>('top-five-county-specialties', filters, this.complianceConnectEndpoint, false, undefined, signal);
    }

    public async getOpenGaps(filters?: ComplianceConnectNetworkFilterParams, signal?: AbortSignal): Promise<OpenGaps> {
        return await this.makeGet<OpenGaps>(`open-gaps`, filters, this.complianceConnectEndpoint, false, undefined, signal);
    }

    public async getRegulatorNetworks(query: GetRegulatorNetworksQuery, signal?: AbortSignal): Promise<GetRegulatorNetworksResult> {
        return await this.makePost<GetRegulatorNetworksResult>(`regulator-networks`, query, this.complianceConnectEndpoint, false, "application/json", true, undefined, signal);
    }

    public async getExceptionReviewStatus(networkIds: string[]): Promise<ExceptionReviewStatus> {
        return await this.makePost<ExceptionReviewStatus>(`exception-review-status`, { networkIds }, this.complianceConnectEndpoint);
    }

    public async getIsolatedGapInstances(filters?: ComplianceConnectNetworkFilterParams, signal?: AbortSignal): Promise<IsolatedGapInstances> {
        return await this.makeGet<IsolatedGapInstances>(`isolated-gap-instances`, filters, this.complianceConnectEndpoint, false, undefined, signal);
    }

    public async getUniqueGapFills(filters?: ComplianceConnectNetworkFilterParams, signal?: AbortSignal): Promise<UniqueGapFills> {
        return await this.makeGet<UniqueGapFills>(`unique-gap-fills`, filters, this.complianceConnectEndpoint, false, undefined, signal);
    }

    public async getIssuerComplianceComparison(networkIds: string[]): Promise<IssuerComplianceComparison[]> {
        return await this.makePost<IssuerComplianceComparison[]>(`issuer-compliance-comparison`, { networkIds }, this.complianceConnectEndpoint);
    }
}
